import React from "react";
import "./Terms_and_condition.css";
import Common_breadcrumb from "../common_components/common-breadcrumb/Common_breadcrumb";

function Terms_and_condition() {
  const breadcrumbsData = [
    { name: "HOMEPAGE", href: "/" },
    { name: "TERMS AND CONDITION", active: true },
  ];

  return (
    <>
      <section className="Terms_and_condition">
        <Common_breadcrumb
          pageName="TERMS AND CONDITION"
          bgImage="/assets/images/Terms_and_condition/bg/bg.png"
          breadcrumbs={breadcrumbsData}
        />

        <div className="policy_text_holder">
          <div className="container">
            <div className="text_holder">
              <p>
                Welcome to <b>MY MDS</b> (“Application”, “Platform”, “We”, “Us”, or
                “Our”). These Terms of Service (“Terms”) govern the use of our
                driving theory provider application by <b>schools, driving schools,
                training centres, and their students.</b> By accessing or using <b>MY
                MDS </b>, you (“Customer” or “School”) and your students (“End
                Users”) agree to these Terms.
              </p>

              <h3>1. Eligibility & Accounts</h3>
              <ul>
                <li>
                  Driving Schools must subscribe and register to access the
                  Platform.
                </li>
                <li>
                  Driving Schools are responsible for distributing student login
                  IDs.
                </li>
                <li>
                  Students under the age of 18 may use the Platform only with
                  the consent of their parent/guardian and their school.
                </li>
              </ul>

              <h3>2. License & Usage</h3>
              <ul>
                <li>
                  We grant Driving Schools a limited, non-exclusive,
                  non-transferable right to use MY MDS to deliver courses to
                  their students.
                </li>
                <li>
                  Students may use the Platform only for personal and
                  educational purposes.
                </li>
                <li>
                  You may not reverse engineer, copy, resell, or misuse the
                  Platform.
                </li>
              </ul>

              <h3>3. Intellectual Property</h3>
              <ul>
                <li>
                  All content, software, course materials, design, and features
                  of MY MDS are owned by us.
                </li>
                <li>
                  Driving Schools may upload or customize certain materials;
                  such materials remain their property.
                </li>
                <li>
                  Unauthorized reproduction or distribution of any content is
                  prohibited.
                </li>
              </ul>

              <h3>4. Responsibilities</h3>
              <ul>
                <li>
                  <h3>
                    <strong>Driving Schools must:</strong>
                  </h3>
                  <ul>
                    <li>
                      Ensure that consent is obtained from students/parents.
                    </li>
                    <li>Monitor student use of the Platform.</li>
                    <li>
                      Use the Platform in compliance with applicable laws.
                    </li>
                  </ul>
                </li>
                <li>
                  <h3>
                    <strong>Students must:</strong>
                  </h3>
                  <ul>
                    <li>Use their login credentials responsibly.</li>
                    <li>
                      Not misuse the Platform or share unauthorized content.
                    </li>
                  </ul>
                </li>

                <li>
                  <h3>
                    <strong>MY MDS will:</strong>
                  </h3>
                  <ul>
                    <li>Provide access to the Platform.</li>
                    <li>Ensure reasonable uptime and technical support.</li>
                    <li>
                      Protect user data as described in our Privacy Policy.
                    </li>
                  </ul>
                </li>
              </ul>

              <h3>5. Subscriptions & Payments</h3>
              <ul>
                <li>
                  Driving Schools must pay subscription fees as per the chosen
                  plan.
                </li>
                <li>Fees are non-refundable except where required by law.</li>
                <li>
                  We reserve the right to suspend accounts for non-payment.
                </li>
              </ul>

              <h3>6. Termination</h3>
              <ul>
                <li>
                  Driving Schools may terminate their subscription at any time
                  by notifying us.
                </li>
                <li>Upon termination, student access will be revoked.</li>
                <li>
                  We may suspend or terminate accounts for violation of these
                  Terms.
                </li>
                <li>
                  Data may be returned or permanently deleted upon termination.
                </li>
              </ul>

              <h3>7. Warranties & Disclaimers</h3>
              <ul>
                <li>
                  The Platform is provided “as is” without warranties of any
                  kind.
                </li>
                <li>
                  We do not guarantee that using MY MDS will ensure success in
                  official driving tests.
                </li>
                <li>
                  We are not responsible for third-party misuse or technical
                  disruptions.
                </li>
              </ul>

              <h3>8. Limitation of Liability</h3>
              <ul>
                <li>
                  Our liability is limited to the amount paid by the Driving
                  School in the last 12 months.
                </li>
                <li>
                  We are not liable for indirect, incidental, or consequential
                  damages.
                </li>
              </ul>

              <h3>9. Indemnification</h3>
              <ul>
                <li>
                  Driving Schools agree to indemnify and hold harmless MY MDS
                  against any claims, misuse, or violations caused by their use
                  of the Platform.
                </li>
              </ul>

              <h3>10. Governing Law & Dispute Resolution</h3>
              <ul>
                <li>These Terms are governed by the laws of India.</li>
                <li>
                  Disputes will be resolved through arbitration in Pune, India.
                </li>
              </ul>

              <h3>11. Updates to Terms</h3>
              <ul>
                <li>We may update these Terms from time to time.</li>
                <li>
                  Driving Schools will be notified of significant changes via
                  email or in-app notification.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Terms_and_condition;
